import axios from 'axios';
import router from 'vue-router';
import VUE_APP_BASE_URL from '../../../config/config';
import Vue from 'vue';

const httpClient = axios.create({
    baseURL: `${VUE_APP_BASE_URL}`,
    headers: {
        'Content-Type': 'application/json',
        Accept: '*/*'
    }
});

httpClient.interceptors.request.use(
    function (config) {
        if (Vue.$cookies.get('token')) {
            config.headers = {
                Authorization:
                    'Bearer ' + Vue.$cookies.get('token').token
            };
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

let isAlreadyFetchingAccessToken = false;
let subscribers = [];

function onAccessTokenFetched(access_token) {
    subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber(callback) {
    subscribers.push(callback);
}

function REFRESH_TOKEN() {
    if (!Vue.$cookies.get('token')) {
        return;
    }
    return httpClient.post('/api/token/refresh', {
        refresh_token: Vue.$cookies.get('token').refresh_token
    });
}

httpClient.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        const {
            config,
            response: {status, data}
        } = error;
        const originalRequest = config;
        if (data.message == 'An authentication exception occurred.') {
            Vue.$cookies.remove('token');
            Vue.$cookies.remove('user');
            router.push({name: 'login'});
        }
        if (status == 401 && Vue.$cookies.get('token')) {
            if (!isAlreadyFetchingAccessToken) {
                isAlreadyFetchingAccessToken = true;
                REFRESH_TOKEN().then(res => {
                    const token = {
                        token: res.data.token,
                        refresh_token: res.data.refresh_token
                    };
                    Vue.$cookies.set('token', token);
                    isAlreadyFetchingAccessToken = false;
                    onAccessTokenFetched(res.data.token);
                });
            }

            return new Promise(resolve => {
                addSubscriber(res => {
                    originalRequest.headers.Authorization = 'Bearer ' + res;
                    resolve(axios(originalRequest));
                });
            });
        }
        return Promise.reject(error);
    }
);

export default httpClient;
